import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { inject } from '@angular/core';
import { MODAL_DATA } from 'src/app/ui/modal/modal-data.token';

export interface ModalData {
	subTitle: string;
	message: string;
}

@Component({
	selector: 'app-delete-package-confirmation-modal',
	imports: [CommonModule],
	templateUrl: './delete-package-confirmation-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeletePackageConfirmationModalComponent {
	public modalData = inject<ModalData>(MODAL_DATA);
}
